export { default } from './HowQrWorks';



// WEBPACK FOOTER //
// ./src/components/templates/HowQrWorks/index.js